const Spinner = () => {
    return (
        <div className="d-flex justify-content-center py-5 my-5">
            <div class="spinner-border text-jobos-green fs-36" style={{ width: "100px", height: "100px" }} role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    )
}
export default Spinner;